/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateOtelDestinationHeaderInput,
  UpdateOtelDestinationHeaderInput$Outbound,
  UpdateOtelDestinationHeaderInput$outboundSchema,
} from "./updateoteldestinationheaderinput.js";

/**
 * OTEL-specific configuration supplied when updating a destination.
 */
export type UpdateOtelDestinationInput = {
  /**
   * OTEL collector endpoint URL.
   */
  endpointUrl: string;
  /**
   * Complete HTTP header-name set for the OTEL destination.
   */
  headers: Array<UpdateOtelDestinationHeaderInput>;
};

/** @internal */
export type UpdateOtelDestinationInput$Outbound = {
  endpoint_url: string;
  headers: Array<UpdateOtelDestinationHeaderInput$Outbound>;
};

/** @internal */
export const UpdateOtelDestinationInput$outboundSchema: z.ZodMiniType<
  UpdateOtelDestinationInput$Outbound,
  UpdateOtelDestinationInput
> = z.pipe(
  z.object({
    endpointUrl: z.string(),
    headers: z.array(UpdateOtelDestinationHeaderInput$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      endpointUrl: "endpoint_url",
    });
  }),
);

export function updateOtelDestinationInputToJSON(
  updateOtelDestinationInput: UpdateOtelDestinationInput,
): string {
  return JSON.stringify(
    UpdateOtelDestinationInput$outboundSchema.parse(updateOtelDestinationInput),
  );
}
